import { useEffect, useRef, useState } from "react";
import Link from "next/link";
import { useRouter } from "next/router";

const LOCALES = ["en", "uk"];
const LABELS = { en: "EN", uk: "UA" };

export default function LanguageSwitcher({
  variant = "desktop",
  onPick,
  className = "",
}) {
  const router = useRouter();
  const { locale, locales, asPath } = router;

  const available =
    (locales && locales.filter((l) => LOCALES.includes(l))) || LOCALES;
  const current = locale || "en";

  // Mobile: сегментований перемикач
  if (variant === "mobile") {
    return (
      <div
        className={
          "inline-flex items-center rounded-xl border border-gray-200 bg-gray-50 p-1 " +
          className
        }
      >
        {available.map((l) => {
          const active = l === current;
          return (
            <Link
              key={l}
              href={asPath}
              locale={l}
              onClick={onPick}
              className={[
                "rounded-lg px-3 py-1.5 text-sm font-semibold transition font-[650]",
                active
                  ? "bg-white text-gray-900 shadow-sm"
                  : "text-gray-600 hover:text-gray-900",
              ].join(" ")}
              aria-current={active ? "true" : "false"}
            >
              {LABELS[l] || l.toUpperCase()}
            </Link>
          );
        })}
      </div>
    );
  }

  // Desktop: компактний dropdown
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onDoc = (e) => {
      if (!ref.current) return;
      if (!ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  return (
    <div ref={ref} className={"relative " + className}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="inline-flex items-center gap-2 rounded-xl border border-gray-200 bg-white px-3 py-2 text-sm font-semibold text-gray-800 shadow-sm hover:bg-gray-50 font-[650]"
        aria-haspopup="menu"
        aria-expanded={open ? "true" : "false"}
      >
        <span className="text-base leading-none">🌐</span>
        <span>{LABELS[current] || current.toUpperCase()}</span>
      </button>

      {open && (
        <div className="absolute right-0 mt-2 w-28 rounded-xl border border-gray-100 bg-white p-1 shadow-xl">
          {available.map((l) => {
            const active = l === current;
            return (
              <Link
                key={l}
                href={asPath}
                locale={l}
                onClick={() => {
                  setOpen(false);
                  onPick?.();
                }}
                className={[
                  "flex items-center justify-between rounded-lg px-3 py-2 text-sm font-semibold transition font-[650]",
                  active
                    ? "bg-gray-900 text-white"
                    : "text-gray-700 hover:bg-gray-50",
                ].join(" ")}
              >
                <span>{LABELS[l] || l.toUpperCase()}</span>
                {active ? <span className="text-xs opacity-80">✓</span> : null}
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
}
